import './Menu.css';
import { useContext } from 'react';
import { AuthContext } from '../../contextos/authContext';
import MenuRender from './MenuRender';

import { permissoesRotas } from '../../util/rotas_roles_permitidas';
import SpinnerLoading from '../SpinnerLoading';

import { CONSTANTES } from '../../util/constantes';

function Menu() {

    const { signed, loading, userRoles } = useContext(AuthContext);

    const menusPublicos = [
        {
            'id': 1, 'nome': 'Painel de Indicadores',
            'submenus': [
                {
                    'id': 1.1,
                    'submenu': 'Gráficos',
                    'linkTo': 'graficos'
                },
                {
                    'id': 1.2,
                    'submenu': 'Ficha Técnica Indicadores',
                    'linkTo': CONSTANTES.DOWNLOAD_FICHA_INDICADORES,
                    'linkExterno': true
                }
            ]
        }
    ]

    const menusPrivados = [
        {
            'id': 2, 'nome': 'Administrador',
            'submenus': [
                {
                    'id': 2.1,
                    'submenu': 'Configurações Gerais',
                    'linkTo': 'admin/configuracoes-gerais',
                    'acceptedRoles': permissoesRotas['configuracoesGerais']
                }, {
                    'id': 2.2,
                    'submenu': 'Gerar Relatórios',
                    'linkTo': 'admin/gerar-relatorios',
                    'acceptedRoles': permissoesRotas['gerarRelatorios']
                }
            ]
        },
        {
            'id': 3, 'nome': 'Indicadores',
            'submenus': [
                {
                    'id': 3.1,
                    'submenu': 'Informar por Planilha',
                    'linkTo': 'indicador/informar-por-planilha',
                    'acceptedRoles': permissoesRotas['informarIndicadores']
                },
                {
                    'id': 3.2,
                    'submenu': 'Ajustar Indicador',
                    'linkTo': 'indicador/ajustar',
                    'acceptedRoles': permissoesRotas['ajustarIndicadores']
                }
            ]
        },
        {
            'id': 4, 'nome': 'Relatório de Acompanhamento',
            'submenus': [
                {
                    'id': 4.1,
                    'submenu': 'Enviar Novo',
                    'linkTo': 'relatorio-acompanhamento/criar',
                    'acceptedRoles': permissoesRotas['criaRelatorioAcompanhamento']
                },
                {
                    'id': 4.2,
                    'submenu': 'Responder Pendências',
                    'linkTo': 'relatorio-acompanhamento/pendencias/responder',
                    'acceptedRoles': permissoesRotas['responderPendencia']
                },
                {
                    'id': 4.3,
                    'submenu': 'Acompanhar Pendências',
                    'linkTo': 'relatorio-acompanhamento/pendencias/acompanhar',
                    'acceptedRoles': permissoesRotas['acompanharPendencias']
                }
            ]
        },
        {
            'id': 5, 'nome': 'Downloads',
            'submenus': [
                {
                    'id': 5.1,
                    'submenu': 'Relatórios NTM',
                    'linkTo': 'download/relatorios',
                    'acceptedRoles': permissoesRotas['downloadRelatorios']
                },
                {
                    'id': 5.3,
                    'submenu': 'Relatório de Acompanhamento',
                    'linkTo': 'download/relatorio-acompanhamento',
                    'acceptedRoles': permissoesRotas['downloadRelatorioAcompanhamento']
                },
            ]
        }
    ]

    function filtraMenuPorRoles(menu, permissoes) {

        return menu.map(secao => {
            const submenusFiltrados = secao.submenus.filter(sub =>
                !sub.acceptedRoles || sub.acceptedRoles.some(p => permissoes.includes(p))
            );

            return {
                ...secao,
                submenus: submenusFiltrados
            };
        })
            .filter(secao => secao.submenus.length > 0); // remove menus sem submenus visíveis
    }

    const menusPrivadosFiltradoPorRoles = filtraMenuPorRoles(menusPrivados, userRoles);

    if (loading) {
        return (
            <div style={{ 'backgroundColor': '#f0eded' }}>
                <SpinnerLoading mensagemLoading='Carregando informações do usuário' />
            </div>
        );
    }

    // se estiver logado, junta as informações de rotas publicas com as rotas privadas, com base no perfil do usuario
    const botoesERotas = signed
        ? [...menusPrivadosFiltradoPorRoles, ...menusPublicos]
        : menusPublicos;

    return (
        <MenuRender botoesERotas={botoesERotas} />
    );

}

export default Menu;
